var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 2.75V2C3.25 0.895431 4.14543 0 5.25 0H7.25C8.35457 0 9.25 0.895431 9.25 2V2.75H11.75C12.1642 2.75 12.5 3.08579 12.5 3.5C12.5 3.91421 12.1642 4.25 11.75 4.25H11.25V12C11.25 13.1046 10.3546 14 9.25 14H3.25C2.14543 14 1.25 13.1046 1.25 12V4.25H0.75C0.335786 4.25 0 3.91421 0 3.5C0 3.08579 0.335786 2.75 0.75 2.75H3.25ZM4.75 2.5H7.75V2C7.75 1.72386 7.52614 1.5 7.25 1.5H5.25C4.97386 1.5 4.75 1.72386 4.75 2V2.5ZM2.75 4.25H9.75V12C9.75 12.2761 9.52614 12.5 9.25 12.5H3.25C2.97386 12.5 2.75 12.2761 2.75 12V4.25Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.e7cdca95fbf8cb76c9510dbcd7d14eec.svg";
export { ForwardRef as ReactComponent };